import React, { useContext, useEffect, useState, Fragment } from "react";

import {
  Container,
  Accordion,
  Icon,
  Table,
  Button,
  Modal,
  TextArea,
  Form,
  Image
} from "semantic-ui-react";
import VariationStore from "../../../../app/stores/variationStore";
import WorkOrderStore from "../../../../app/stores/workorderStore";
import UserAuthStore from "../../../../app/stores/userauthStore";

import { observer } from "mobx-react-lite";
import { IVariation } from "../../../../app/models/variation";
import { IVariationsor } from "../../../../app/models/variationsor";
import Slider from "react-slick";
import { IVariationphoto } from "../../../../app/models/variationphoto";

//ADD221031 - for dyn token & api 
import Axios, { AxiosResponse } from 'axios'
import config from '../../../../app/api/apiconfig';
const tokenUrl = config.app.tokenUrl
const integtokenUrl = config.app.integtokenUrl
const getusrauthbaseUrl = config.app.getusrauthbaseUrl
const getwkorderbaseUrl = config.app.getinvoiceguidUrl
//

interface IProps {}

const WorkOrderVariations: React.FC<IProps> = props => {
  const [activeIndex, setActiveIndex] = useState();
  const [confBoxOpen, setconfBoxOpen] = useState(false);
  const [varImageBoxOpen, setVarImageBoxOpen] = useState(false);
  const [confBoxSorId, setBoxSorId] = useState();
  const [confBoxFunc, setconfBoxFunc] = useState();
  const [VarImageBoxFunc, setVarImageBoxFunc] = useState();
  const [confDeclineRec, setconfDeclineRec] = useState();
  //ADD221031
  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!)
  let IsLoggedIn = sessionStorage.getItem("isLoggedIn")
  const [userauthdata,setuserauthData] = useState('');
  const [userauthordertype,setuserauthOrdertype] = useState('');
  const [userauthvarylimit,setuserauthVarylimit] = useState('');
  const [userauthguid,setuserauthGuid] = useState('');
  const [orderapptype,setOrderappbasetype] = useState('');
  const [disallowapprove, setDisallowapprove] = useState(false)

  //ADD250912
  const [isApprovalButtonDisabled, setIsApprovalButtonDisabled] = useState(false);

  const variationStore = useContext(VariationStore);
  const workorderStore = useContext(WorkOrderStore);
  const userauthStore = useContext(UserAuthStore);

  const {
    VariationsRequiringApprovals: requiredApprovalVariations
  } = variationStore;
  const { selectedWorkOrder: currWorkOrder } = workorderStore;
  const handleClick = (e: any, titleProps: any) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const closeModal = () => {
    setconfBoxOpen(false);
  };

  const closeVarModal = () => {
    setVarImageBoxOpen(false);
  };

  const setApprovalStatusConfirmBox = (e: any, data: any) => {
    var id = data.id;
    var func = data.children;
    setBoxSorId(id);
    setconfBoxFunc(func);
    setconfBoxOpen(true);
  };

  const setVariationImagesBox = (e: any) => {
    var id = e;
    setVarImageBoxFunc(e);
    setVarImageBoxOpen(true);
  };

  const createVariationGallery = (e: IVariationphoto[]) => {
    const varPhotos = e.map(ph => <Image src={decodeURIComponent(ph.url)} />);
    return varPhotos;
  };

  const handleChange = (val: any) => {
    setconfDeclineRec(val.target.value);
  };

  const toggleApprovalButtonDisabled = () => {
    setIsApprovalButtonDisabled(true);
  };

  const setApprovalStatus = (e: any, data: any) => {
    console.log(confBoxSorId,confBoxFunc,confDeclineRec)
    if( confBoxSorId !== undefined && confBoxFunc !== undefined) {
      variationStore.setApprovalStatus(
        confBoxSorId,
        confBoxFunc,
        confDeclineRec,
        userauthStore.LoggedInObj!.User.FirstName +
          " " +
          userauthStore.LoggedInObj!.User.LastName
      );
    }
  };
  
  const setAllSorToApproved = ( data: any) => { 
    var approve = "Approve Sor"
    var reason = ""
    var id = data

    //sets all sors to approved
    variationStore.setApprovalStatus(
      id,
      approve,
      reason,
      userauthStore.LoggedInObj!.User.FirstName + 
        " " +
        userauthStore.LoggedInObj!.User.LastName
    );
  };

  const getAppStatusColour = (st: string) => {
    if (st.toLowerCase() === "approved")
      return <Icon name="check circle" color="green" size="large" />;
    if (st.toLowerCase() === "rejected")
      return <Icon name="times circle" color="red" size="large" />;
    if (st.toLowerCase() === "pending")
      return <Icon name="stopwatch" size="small" />;
  };

  var AllSors: IVariationsor[];
   const getAllSorRows = (varSors: IVariationsor[]) => {
    var Sorarray = [""]
    toggleApprovalButtonDisabled()
    varSors.map((vr, index) => (Sorarray.push(vr.VarSorId)))
    Sorarray.forEach(Element => { setAllSorToApproved(Element)},
    window.alert("All SOR's have been approved")
    );
  }

  const getSORRowsForApproval = (vaSors: IVariationsor[], varvalue) => {
    var vaSRs = vaSors.map((vr, index) => (
      <Table.Row>
        <Table.Cell>{vr.SORDescripion}</Table.Cell>
        <Table.Cell>{vr.SORQty}</Table.Cell>
        <Table.Cell>{vr.SORValue}</Table.Cell>
        <Table.Cell>{vr.VarComment}</Table.Cell>
        <Table.Cell>{vr.ApprovalStatus}</Table.Cell>
        <Table.Cell>{vr.ApprovedDeclinedBy}</Table.Cell>
        <Table.Cell>
          {
          disallowapprove === true || validateuserauth(userauthdata,userauthordertype,userauthvarylimit,varvalue,orderapptype) > 0 ? 
          (
            validateuserauth(userauthdata,userauthordertype,userauthvarylimit,varvalue,orderapptype) == 2 ? 
            (<Button disabled style={{ float: "right"}} data-userdata = {userauthdata} data-userauthordertype = {userauthordertype}>
              Amount Over User Approval Limit
            </Button>):
            validateuserauth(userauthdata,userauthordertype,userauthvarylimit,varvalue,orderapptype) == 3 ?
            (<Button disabled style={{ float: "right"}} data-userdata = {userauthdata} data-userauthordertype = {userauthordertype}>
              User Restricted to this Order Type
            </Button>):
            (<Button disabled style={{ float: "right"}} data-userdata = {userauthdata} data-userauthordertype = {userauthordertype}>
              User Approval Restricted
            </Button>)
          ):
          (
          vr.ApprovalStatus.toLowerCase() === "pending" ||
          vr.ApprovalStatus === null ? (
            <div>
              <Button
                id={vr.VarSorId}
                size="mini"
                color="green"
                onClick={setApprovalStatusConfirmBox}
              >
                Approve SOR
              </Button>
              <Button
                id={vr.VarSorId}
                size="mini"
                color="red"
                onClick={setApprovalStatusConfirmBox}
              >
                Decline SOR
              </Button>
            </div>
          ) : (
            getAppStatusColour(vr.ApprovalStatus)
          ))
        
        }
        </Table.Cell>
      </Table.Row>
    ));

    return vaSRs;
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    adaptiveWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const showActiveVarRequests = (vars: IVariation[]) => {
    if (vars !== null) {
      var varHist = vars.map((vr, index) => (
        <Fragment>
          <Accordion.Title
            active={activeIndex === index}
            index={index}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            {getAppStatusColour(vr.AppStatus)} <b> {vr.Name} </b>{" "}
            <div style={{ float: "right" }}>
              <Icon name="pound sign" />
              {vr.Value}
            </div>
          </Accordion.Title>
          <Accordion.Content active={activeIndex === index}>
            <div
              className="ag-theme-material"
              style={{ height: "200px", width: "100%" }}
            >
              <Button
                icon
                labelPosition="left"
                onClick={() => setVariationImagesBox(vr.Name)}
              >
                <Icon name="photo" />
                Variation Photos
              </Button>
              {
              disallowapprove === true || validateuserauth(userauthdata,userauthordertype,userauthvarylimit,vr.Value,orderapptype) > 0 ? 
              (
                validateuserauth(userauthdata,userauthordertype,userauthvarylimit,vr.Value,orderapptype) == 2 ? 
                (<Button disabled style={{ float: "right"}} data-userdata = {userauthdata} data-userauthordertype = {userauthordertype}>
                  Amount Over User Approval Limit
                </Button>)
                :
                validateuserauth(userauthdata,userauthordertype,userauthvarylimit,vr.Value,orderapptype) == 3 ?
                (<Button disabled style={{ float: "right"}} data-userdata = {userauthdata} data-userauthordertype = {userauthordertype}>
                  User Restricted to this Order Type
                </Button>)
                :
                (<Button disabled style={{ float: "right"}} data-userdata = {userauthdata} data-userauthordertype = {userauthordertype}>
                  User Approval Restricted
                </Button>)
              ):
              (
              <Button
                icon
                style={{ float: "right"}}   
                labelPosition="left"
                disabled={isApprovalButtonDisabled}
                onClick={() => {getAllSorRows(vr.VarSors)}} //approve all variations 
              >
                <Icon color="green" name="plus" />
                Approve all
              </Button>                
              )
              }

              <Table unstackable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>SOR</Table.HeaderCell>
                    <Table.HeaderCell>Qty</Table.HeaderCell>
                    <Table.HeaderCell>Value</Table.HeaderCell>
                    <Table.HeaderCell>Comments</Table.HeaderCell>
                    <Table.HeaderCell>Approval Status</Table.HeaderCell>
                    <Table.HeaderCell>Approver</Table.HeaderCell>
                    <Table.HeaderCell>Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>{getSORRowsForApproval(vr.VarSors, vr.Value)}</Table.Body>
              </Table>
            </div>
          </Accordion.Content>

          <Modal dimmer={"blurring"} open={confBoxOpen}>
            <Modal.Header>{confBoxFunc} - Are you sure?</Modal.Header>
            <Modal.Content>
              <Modal.Description>
                {confBoxFunc === "Approve SOR" ? (
                  <p>Are you sure you would like to approve this SOR?</p>
                )
                 : 
                (
                  <div>
                    <p>
                      Rejecting any line will reject the entire variation.
                      Please ensure you have approved all other SORs that are
                      correct to help us deal with this rejection more
                      efficiently.
                    </p>

                    <h4>Decline Reason</h4>
                    <Form>
                      <TextArea
                        placeholder="Please complete a reason for the decline"
                        onChange={handleChange}
                      />
                    </Form>
                  </div>
                )}
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              {variationStore.settingapproval === true ? (
                <Button color="green" loading disabled onClick={setApprovalStatus}>
                  {confBoxFunc}
                </Button>
              ) : (
                <Button color="green" onClick={setApprovalStatus}>
                  {confBoxFunc}
                </Button>
              )}

              <Button color="red" onClick={closeModal}>
                Cancel
              </Button>
            </Modal.Actions>
          </Modal>

          <Modal
            dimmer={"blurring"}
            open={varImageBoxOpen}
            onClose={closeVarModal}
            closeIcon
          >
            <Modal.Header>Variation Images</Modal.Header>
            <Modal.Content>
              <Modal.Description>
                Please check the following Variation Images
              </Modal.Description>

              <Slider {...settings}>
                {createVariationGallery(vr.VarPhotos)}
              </Slider>
            </Modal.Content>
          </Modal>
        </Fragment>
      ));
      return varHist;
    }
  };

  //ADD221031 - for validating the approval auth of each variation 
function validateuserauth(userauthdata:string,userauthordertype:string,userauthvarylimit,varyvalue,orderstream){
  let disallowapprove = 0;
  console.log ("userauthdata:", userauthdata)
  if(userauthdata == '870110000'){
    //allow all
  } else if(userauthdata == '870110001') {
    //disallow all
    disallowapprove = 1;
  } else if(userauthdata == '870110002') {
    //limited amount
    var varydec = parseFloat (varyvalue);
    var vlmtdec = parseFloat (userauthvarylimit);
    if (varydec > vlmtdec) {
      disallowapprove = 2;
    }
  } else if(userauthdata == '870110003') {
    //limited ordertype
    var usrauthtype = userauthordertype.split(',');
    console.log ("usrauthtype:", usrauthtype)
    var orderstreamstr = '' + orderstream + ''
    var haveauth = usrauthtype.includes(orderstreamstr);
    console.log ("haveauth:", haveauth, orderstreamstr )
    if (!haveauth) {
      disallowapprove = 3;
    }
  } else if(userauthdata == '870110004') {
    //limited amount and type
    var varydec = parseFloat (varyvalue);
    var vlmtdec = parseFloat (userauthvarylimit);
    if (varydec > vlmtdec) {
      //over amount
      disallowapprove = 2;
    }
    var usrauthtype = userauthordertype.split(',');
    console.log ("usrauthtype:", usrauthtype)
    var orderstreamstr = '' + orderstream + ''
    var haveauth = usrauthtype.includes(orderstreamstr);
    console.log ("haveauth:", haveauth, orderstreamstr )
    if (!haveauth) {
      //ordertype disallowed
      disallowapprove = 3;
    }
  }
  return disallowapprove
}

//ADD221031 - for the second method to get dyna token 
function getintegtoken(){
  let validToken = ""
  console.log ("getintegtokenUrl:", integtokenUrl)
    Axios.get(integtokenUrl).then(response => {
        if(response.status === 200){
          var responsedata = response.data;
          if (responsedata != null && responsedata.length > 9) {
            validToken = responsedata
            sessionStorage.setItem('token', responsedata)
          }
        }
    });
  }

//ADD221031 - for the retrieve of portaluser thru dynamic
function getPortalUserData(usrname:string,client:string){
  try
  {
    let validToken = ""
    if (sessionStorage.getItem("token")){
      validToken = sessionStorage.getItem("token")
      //console.log ("sessionToken:", sessionStorage.getItem("token"))
    } else{
      getintegtoken()
      validToken = sessionStorage.getItem("token")
    }      

    let thisusername = usrname;
    let thisclient = client;
    let thisfilter = ""
    if (thisusername.length > 3 && thisclient.length > 3){
      thisfilter = "$select=exactly_name,gilm_variationapprovalauth,gilm_uservariationapprovalordertype,gilm_uservariationapprovallimit&$filter=(exactly_name eq '" + thisusername + "' and _exactly_client_value eq '" + thisclient + "' )"
    } else{
      thisfilter = "$select=exactly_name,gilm_variationapprovalauth,gilm_uservariationapprovalordertype,gilm_uservariationapprovallimit&$filter=(exactly_name eq '" + thisusername + "' and _exactly_client_value eq '" + thisclient + "' )"
    }

    let geturl = getusrauthbaseUrl + "?" + thisfilter
    let config  = {
      headers: {
        'Authorization': 'Bearer ' + validToken
      }
    }
    console.log('geturl',geturl)
    Axios.get(geturl, config)
      .then(response => {
          if(response.status === 200){
            var getvalue = response.data.value[0].exactly_portaluserid;
            console.log('get1st',getvalue);
            if (getvalue == null || getvalue.length < 3){
              getvalue = " "
              setuserauthData(getvalue)
              setuserauthGuid(getvalue)
              setuserauthOrdertype(getvalue)
              setuserauthVarylimit(getvalue)
            }
            else{
              setuserauthData(response.data.value[0].gilm_variationapprovalauth)
              setuserauthGuid(response.data.value[0].exactly_portaluserid)
              setuserauthOrdertype(response.data.value[0].gilm_uservariationapprovalordertype)
              setuserauthVarylimit(response.data.value[0].gilm_uservariationapprovallimit)
            }
          }
      }).catch((error) =>{
        if (error.response && error.response.status === 401) {
            console.log('TokenError',error.response)
            getintegtoken()
            validToken = sessionStorage.getItem("token")
            config  = {
              headers: {
                'Authorization': 'Bearer ' + validToken
              }
            }
            Axios.get(geturl, config).then(response => {
            if(response.status === 200){
              var getvalue = response.data.value[0];
              console.log('get2nd',getvalue);
              if (getvalue == null){
                getvalue = " "
                setuserauthData(getvalue)
                setuserauthGuid(getvalue)
                setuserauthOrdertype(getvalue)
                setuserauthVarylimit(getvalue)
              }
              else{
                setuserauthData(getvalue.gilm_variationapprovalauth)
                setuserauthGuid(getvalue.exactly_portaluserid)
                setuserauthOrdertype(getvalue.gilm_uservariationapprovalordertype)
                setuserauthVarylimit(getvalue.gilm_uservariationapprovallimit)
              }
            }
            })
        }
      }).finally(()=>{
        console.log('userauth>>',userauthguid, userauthdata, userauthordertype, userauthvarylimit);
        if(userauthdata !== undefined && userauthdata != null){
          if(userauthdata == '870110000'){
            setDisallowapprove(false);
          } else if(userauthdata == '870110001'){
            setDisallowapprove(true);
          }
        }
      });
  
    }
  catch(ex){
      console.error("An error has occurred: " + ex)
  }
}
//ADD221031 - for the retrieve of ordertyperelated thru dynamic
function getOrderTypeData(orderid:string){
  try
  {
    let validToken = ""
    if (sessionStorage.getItem("token")){
      validToken = sessionStorage.getItem("token")
      //console.log ("sessionToken:", sessionStorage.getItem("token"))
    } else{
      getintegtoken()
      validToken = sessionStorage.getItem("token")
    }      

    let thisusername = orderid.trim();
    let thisfilter = "$select=msdyn_name,_msdyn_workordertype_value&$expand=msdyn_workordertype($select=msdyn_name,gilm_approvalbasetype)"
    let geturl = getwkorderbaseUrl + "(" + thisusername + ")?" + thisfilter + " "
    let config  = {
      headers: {
        'Authorization': 'Bearer ' + validToken
      }
    }
    console.log('geturlordtype',geturl)
    Axios.get(geturl, config)
      .then(response1 => {
          if(response1.status === 200){
            var getvalue1 = response1.data.msdyn_workorderid;
            console.log('get1stordtype',getvalue1);
            if (getvalue1 == null || getvalue1.length < 9){
              getvalue1 = " "
              setOrderappbasetype(getvalue1)
            }
            else{
              console.log('gilm_approvalbasetype',response1.data.msdyn_workordertype.gilm_approvalbasetype);
              setOrderappbasetype(response1.data.msdyn_workordertype.gilm_approvalbasetype)
            }
          }
      }).catch((error) =>{
        if (error.response && error.response.status === 401) {
            console.log('TokenError',error.response)
            getintegtoken()
            validToken = sessionStorage.getItem("token")
            config  = {
              headers: {
                'Authorization': 'Bearer ' + validToken
              }
            }
            Axios.get(geturl, config).then(response => {
            if(response.status === 200){
              var getvalue = response.data.msdyn_workorderid;
              console.log('get2nd',getvalue);
              if (getvalue == null){
                getvalue = " "
                setOrderappbasetype(getvalue)
              }
              else{
                setOrderappbasetype(response.data.msdyn_workordertype.gilm_approvalbasetype)
              }
            }
            })
        }
      }).finally(()=>{
        console.log('orderapptype>>',orderapptype);
      });
  
    }
  catch(ex){
      console.error("An error has occurred: " + ex)
  }
}

  useEffect(() => {
    var id = currWorkOrder!.JobId;
    console.log('varload', id)
    console.log('currworkorder',currWorkOrder!)
    //ADD221031 - for variation approval auth
    getPortalUserData(sessionObj.User.Username,sessionObj.Client.Id)
    //ADD230723 - LIVE not needed
    //getOrderTypeData(id)
    
    //changed with username
    variationStore.loadWorkOrderVariations(id, sessionObj.User.Username);
    showActiveVarRequests(requiredApprovalVariations);
  }, [currWorkOrder]);

  useEffect(() => {
    if (variationStore.VariationResponse !== undefined) {
      closeModal();
      if ((variationStore.VariationResponse.IsCompleted === true) ) {
        variationStore.VariationsRequiringApprovals = [];
        variationStore.selectedWorkOrder = undefined;
        variationStore.VariationResponse = undefined;
        window.location.reload();
      } else {
        //changed with username
        variationStore.loadWorkOrderVariations(currWorkOrder!.JobId,sessionObj.User.Username);
        variationStore.VariationResponse = undefined;
      }
    }
  }, [variationStore.VariationResponse]);

  return (
    <Container>
      <div
        className="ag-theme-material"
        style={{ height: "200px", width: "100%" }}
      >
        <Accordion fluid styled>
          {showActiveVarRequests(requiredApprovalVariations)}
        </Accordion>
      </div>
    </Container>
  );
};

export default observer(WorkOrderVariations);
